module.exports = __webpack_public_path__ + "static/media/delly-challenge_icon2.ead7f434.svg";